import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchPackingData, fetchSaleInvoiceReg } from '../../../Store/PHPSlice/Packing/PackApis';
import { selectPackingData, selectSaleInvoiceReg } from '../../Selectors/PackSelector/PackingSelector';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';


const InvoiceBill = () => {
    const { Id } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [formData, setFormData] = useState({
        pkId: Id
    })
    const [packInfo, setPackInfo] = useState([]);

    const packData = useSelector(selectSaleInvoiceReg);
    // console.log(packData)
    useEffect(() => {
        dispatch(fetchSaleInvoiceReg(Id));

    }, [Id, dispatch]);

    useEffect(() => {
        if (packData?.data) {
            const item = packData?.data;
            setFormData(prev => ({
                ...prev,
                billNo: item.billNo,
                cgst: item.cgst,
                discnt_amt: item.discnt_amt,
                discnt_type: item.discnt_type,
                discnt_val: item.discnt_val,
                dt: item.dt,
                firmId: item.firmId,
                firmNm: item.firmNm,
                firm_tax_sts: item.firm_tax_sts,
                freight_ch: item.freight_ch,
                gst_val: item.gst_val,
                igst: item.igst,
                lrdt: item.lrdt,
                lrno: item.lrno,
                net_amt: item.net_amt,
                other_ch: item.other_ch,
                parcelqty: item.parcelqty,
                partyId: item.partyId,
                partyNm: item.partyNm,
                party_state: item.party_state,
                sgst: item.sgst,
                sts: item.sts,
                total_amt: item.total_amt,
                totqty: item.totqty,
                pkMemo: item.pkMemo,
                pkdt: item.pkdt,
                transptNm: item.transptNm,
                shipNm: item.shipNm,
                shipadrs: item.shipadrs,
            }));
        }
        if (packData?.Info && packData.Info?.length > 0) {
            const info = packData.Info;
            setPackInfo(info);
        }
    }, [packData]);


    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%' }}>
                    {/* Heading */}
                    {formData.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                    <h3 className="heading">Invoice Bill</h3>

                    <table className="main-table">

                        <tbody>

                            <tr>
                                <td>Firm:</td>
                                <td>{formData.firmNm}</td>
                                <td>Bill Date:</td>
                                <td>{formData.dt}</td>
                            </tr>
                            <tr>
                                <td>Bill No:</td>
                                <td>{formData.billNo}</td>
                                <td>Packing Slip Date:</td>
                                <td>{formData.pkdt}</td>
                            </tr>
                            <tr>
                                <td>Packing Slip Memo:</td>
                                <td>{formData.pkMemo}</td>

                                <td>Transport Name:</td>
                                <td>{formData.transptNm}</td>
                            </tr>
                            <tr>
                                <td>Party:</td>
                                <td>{formData.partyNm}</td>
                                <td>Parcel Qty:</td>
                                <td>{formData.parcelqty}</td>
                            </tr>
                            <tr>
                                <td>Lr No:</td>
                                <td>{formData.lrno}</td>
                                <td>Lr Date:</td>
                                <td>{formData.lrdt}</td>
                            </tr>
                            <tr>
                                <td>Ship To:</td>
                                <td>{formData.shipNm}</td>
                                <td>Ship Address:</td>
                                <td>{formData.shipadrs}</td>
                            </tr>


                        </tbody>
                    </table>


                    {/* Main Table */}
                    {packInfo.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.rate}</td>
                                        <td>{item.amt}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{formData.totqty}</b></td>
                                    <td></td>
                                    <td><b>{formData.total_amt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }

                    <table className="main-table">

                        <tbody>

                            <tr>
                                <td>GST(%):</td>
                                <td>{formData.gst_val}</td>
                                {/* <td>Bill Date:</td>
                                <td>{formData.dt}</td> */}
                            </tr>
                            <tr>
                                <td>Total Quantity:</td>
                                <td>{formData.totqty}</td>
                                <td>Total Amount:</td>
                                <td>{formData.total_amt}</td>
                            </tr>
                            <tr>
                                <td>Freight Charges:</td>
                                <td>{formData.freight_ch}</td>

                                <td>Discount Amount {formData.discnt_val}({formData.discnt_type}):</td>
                                <td>{formData.discnt_amt}</td>
                            </tr>
                            <tr>
                                <td>Other Charges:</td>
                                <td>{formData.other_ch}</td>
                                <td>Gross Total:</td>
                                <td>{parseFloat(formData.total_amt) + parseFloat(formData.discnt_amt)}</td>
                            </tr>
                            <tr>
                                <td>IGST:</td>
                                <td>{formData.igst}</td>
                                <td>CGST:</td>
                                <td>{formData.cgst}</td>
                            </tr>
                            <tr>
                                <td>SGST:</td>
                                <td>{formData.sgst}</td>
                                <td><b>Grand Total:</b></td>
                                <td><b>{formData.net_amt}</b></td>
                            </tr>


                        </tbody>
                    </table>

                </div>

                <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div>
            </Paper>
        </Grid>
    );
};

export default InvoiceBill;
